import { cloudBurst } from '@paradigm/design-system/src/colors';
import formatDecimal from '@paradigm/utils/formatDecimal';

import checkIcon from '@paradigm/design-system/src/assets/icon-check.svg';

import toast, { ToastOptions } from '#/components/toasts/toast';
import {
  Container,
  Description,
  DescriptionContainer,
  Price,
  PriceContainer,
  PriceTitle,
  Quantity,
  Title,
} from './components';
import LegacyToastIcon from './LegacyToastIcon';

export interface ToastableQuote {
  readonly side?: 'BUY' | 'SELL' | undefined;
  readonly original_quantity: string;
  readonly price: string;
}

export function toastQuoteCreated(
  quote: ToastableQuote,
  description: string,
  options: Partial<ToastOptions> = {},
) {
  toast(getContent(quote, description), {
    icon: <LegacyToastIcon src={checkIcon} />,
    position: 'top-right',
    styles: {
      backgroundColor: cloudBurst,
      borderColor: cloudBurst,
      color: 'white',
    },
    ...options,
  });
}

function getContent(quote: ToastableQuote, description: string) {
  const { side } = quote;
  const quantity = formatDecimal(quote.original_quantity);
  const price = formatDecimal(quote.price);

  return (
    <Container data-testid="quote-info-toast">
      <Title>Limit {side ? `${side} ` : ''}Order Created</Title>
      <DescriptionContainer>
        <Description>{description}</Description>
        <Quantity>{quantity}x</Quantity>
      </DescriptionContainer>
      <PriceContainer>
        <PriceTitle>at</PriceTitle>
        <Price>{price}</Price>
      </PriceContainer>
    </Container>
  );
}
